var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.674,
    height: 21.261,
    viewBox: "0 0 20.674 21.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5183",
    "data-name": "Rectangle 5183",
    width: 20.674,
    height: 21.261,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6857",
    "data-name": "Group 6857",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6859",
    "data-name": "Group 6859",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8987",
    "data-name": "Path 8987",
    d: "M12.222,0H3.3A3.244,3.244,0,0,0,0,3.174V18.088a3.244,3.244,0,0,0,3.3,3.173h8.922a3.244,3.244,0,0,0,3.3-3.173V3.174A3.244,3.244,0,0,0,12.222,0m1.863,18.087a1.805,1.805,0,0,1-1.866,1.738H3.3a1.808,1.808,0,0,1-1.866-1.738V13.872l0-.009V3.174A1.805,1.805,0,0,1,3.3,1.436h8.918a1.808,1.808,0,0,1,1.866,1.738V7.39l0,.009Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8988",
    "data-name": "Path 8988",
    d: "M3.437,5.647H12.25a.718.718,0,0,0,.009-1.436H3.437a.718.718,0,0,0-.009,1.436Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8989",
    "data-name": "Path 8989",
    d: "M3.437,9.418H7.371A.718.718,0,1,0,7.38,7.982H3.437a.718.718,0,0,0-.009,1.436Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8990",
    "data-name": "Path 8990",
    d: "M3.437,13.19H7.371a.717.717,0,1,0,0-1.435H3.437a.717.717,0,1,0,0,1.435",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8991",
    "data-name": "Path 8991",
    d: "M17.433,10.635A3.525,3.525,0,1,1,13.908,7.11a3.525,3.525,0,0,1,3.525,3.525",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8992",
    "data-name": "Path 8992",
    d: "M13.908,14.91a4.275,4.275,0,1,1,4.275-4.275,4.28,4.28,0,0,1-4.275,4.275m0-7.05a2.775,2.775,0,1,0,2.775,2.775A2.777,2.777,0,0,0,13.908,7.86",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8993",
    "data-name": "Path 8993",
    d: "M19.924,17.4a.746.746,0,0,1-.53-.22l-3.5-3.5a.75.75,0,0,1,1.06-1.06l3.5,3.5a.75.75,0,0,1-.531,1.28",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8994",
    "data-name": "Path 8994",
    d: "M3.437,16.961H12.25a.718.718,0,1,0,0-1.435H3.437a.718.718,0,1,0,0,1.435",
    fill: "#003189"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.b04eecf9eba46c21d62a0176827ba91c.svg";
export { ForwardRef as ReactComponent };